import React from 'react'
import { OverContainerSection, OverSection } from './styles'
import { DataInformation } from './dataInformation'
import { SearchSection } from './searchSection'
import { ProfileSectionProps } from 'pages/DetailedBlogs/InformationSection/Types'

export const InformationSection = ({ Blog }: ProfileSectionProps) => {
    return (
        <OverContainerSection>
            <OverSection marginTop={['xlarge', 'xlarge', 'xlarge', 'xtitle']}>
                <DataInformation Blog={Blog} />
                <SearchSection />
            </OverSection>
        </OverContainerSection>
    )
}
